import { ApexOptions } from 'apexcharts';

import { TFunction } from 'i18next';

interface ChartData {
  week_or_month_name: string[];
  amount: number[];
}

export const vulsPeriodLineChartOptions = (chartData: ChartData, t: TFunction, title?: string, zoom?: boolean) => {
  const chartOptions: ApexOptions = {
    series: [
      {
        name: t('ChartsAnalitics.bait_chart.data_labels'),
        data: chartData.amount || [],
      },
    ],
    chart: {
      height: 350,
      type: 'area',
      zoom: {
        enabled: zoom,
      },
      toolbar: {
        show: !title,
      },
    },
    markers: {
      size: 3,
      shape: 'circle',
    },
    stroke: {
      width: [3, 3],
      curve: ['smooth', 'straight', 'stepline'],
    },
    xaxis: {
      title: {
        text: t('ChartsAnalitics.bait_chart.x_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      categories: chartData.week_or_month_name || [],
      type: 'category',
      tickPlacement: 'on',
    },
    yaxis: {
      title: {
        text: t('ChartsAnalitics.bait_chart.y_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
    },
    colors: ['#6A37D4'],
    ...(title
      ? {
          title: {
            text: title,
            align: 'center',
            style: {
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#000',
            },
          },
        }
      : {}),
  };

  return chartOptions;
};
